import { Image, Stack, Text } from "@chakra-ui/react";
import { MdOutlineCallEnd, MdKeyboardArrowDown } from "react-icons/md";
import { BsMic, BsCameraVideo, BsThreeDots } from "react-icons/bs";
import { BiMessage } from "react-icons/bi";
import { FiUserPlus } from "react-icons/fi";

function MessageCallingSection({ setShowCall }) {
  return (
    <Stack
      alignItems={"center"}
      background="linear-gradient(90deg, #47297D 1.5%, #46287B 18.36%, #6F346F 98.4%)"
      flex="6"
      h="100%"
      py="20px"
      spacing={"45px"}
    >
      <Stack direction={"row"} spacing="30px" alignItems={"center"}>
        <Text color="#fff" fontSize={".87em"}>
          Michael Wong
        </Text>
      </Stack>
      <Stack border="30px solid #ffffff14" borderRadius={"50%"}>
        <Stack border="20px solid #ffffff2b" borderRadius={"50%"}>
          <Image
            borderRadius={"50%"}
            w="200px"
            objectFit={"cover"}
            src=""
            alt=" user pic"
            fallbackSrc="https://via.placeholder.com/150"
          />
        </Stack>
      </Stack>

      <Stack
        direction={"row"}
        alignItems="center"
        spacing={"60px"}
        color="#fff"
        fontSize={"2em"}
      >
        <BsMic />
        <BsCameraVideo />
        <Stack
          bg="#DD6062"
          borderRadius={"50%"}
          p="10px"
          cursor={"pointer"}
          onClick={() => setShowCall(false)}
        >
          <MdOutlineCallEnd />
        </Stack>
        <FiUserPlus />
        <BsThreeDots />
      </Stack>
      <Stack color="#fff" fontSize={"2em"}>
        <BiMessage />
      </Stack>
      <Stack color="#fff" fontSize={"1.5em"}>
        <MdKeyboardArrowDown />
      </Stack>
    </Stack>
  );
}

export default MessageCallingSection;
